<template>
  <nav v-if="showNav && !this.currentUser" class="app-nav">
    <v-container fluid>
      <v-toolbar
        density="compact"
        style="background-color: #ffffff"
        class="elevation-0 align-center"
        height="74"
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        class="text-grey-darken-2 hidden-md-and-up"
      ></v-app-bar-nav-icon>
        <div class="d-flex align-center cursor-pointer" @click="routeToPage('/')">
          <div class="mt-1 mb-1 mr-2">
            <v-img
                lazy
                height="40"
                width="40"
                :src="require('../assets/logo.png')"
            ></v-img>
          </div>
          <div class="text-subtitle-1 ml-n1">
            <span class="font-weight-black teks-effect-toright hidden-sm-and-down">DPMD</span>
            <div
                class="text-subtitle-2 mt-n3 text-grey-darken-2 font-weight-light hidden-sm-and-down"
            >
              Kabupaten Bekasi
            </div>
          </div>
        </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
        <div class="hidden-sm-and-down">
          <v-btn
              class="hidden-sm-and-down"
              size="small"
              density="comfortable"
              :variant="isActive('/home')?'elevated':'plain'"
              :class="isActive('/home')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
              elevation="0"
              :to="{ path: '/home' }"
              v-if="!currentUser"
          >
            <span>Beranda</span>
          </v-btn>
        </div>
      </v-toolbar-items>


        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/public-profil')?'elevated':'plain'"
                :class="isActive('/public-profil')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-profil' }"
                v-if="!currentUser"
            >
              <span>Profil</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/public-berita')?'elevated':'plain'"
                :class="isActive('/public-berita')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-berita' }"
                v-if="!currentUser"
            >
              <span>Berita</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/public-ppid')?'elevated':'plain'"
                :class="isActive('/public-ppid')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-ppid' }"
                v-if="!currentUser"
            >
              <span>PPID</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/public-layanan')?'elevated':'plain'"
                :class="isActive('/public-layanan')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-layanan' }"
                v-if="!currentUser"
            >
              <span>Layanan</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isActive('/public-saran')?'elevated':'plain'"
                :class="isActive('/public-saran')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-saran' }"
                v-if="!currentUser"
            >
              <span>Saran</span>
            </v-btn>
          </div>
        </v-toolbar-items>
        <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
          <div class="hidden-sm-and-down">
            <v-btn
                class="hidden-sm-and-down"
                size="small"
                density="comfortable"
                :variant="isSurveyRouteActive()?'elevated':'plain'"
                :class="isSurveyRouteActive()?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                elevation="0"
                :to="{ path: '/public-daftar-survey' }"
                v-if="!currentUser"
            >
              <span>Survey</span>
            </v-btn>
          </div>
        </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down d-flex flex-column align-center justify-center">
        <v-menu
            class="mt-10"
            transition="slide-y-transition"
        >
          <template v-slot:activator="{ props }">
            <div class="hidden-sm-and-down">
              <v-btn
                  v-bind="props"
                  size="small"
                  density="comfortable"
                  :variant="isActive('/public-e-library')?'elevated':'plain'"
                  :class="isActive('/public-e-library')?'color-bg-primary pa-3 text-white font-weight-bold' : 'pa-3 text-black font-weight-bold hover-btn'"
                  @click="switchOn = 'library'"
                  elevation="0"
                  v-if="!currentUser"
              >
                <span>Dokumen</span>
              </v-btn>
            </div>
          </template>
          <v-card width="900" class="color-bg-grey">
            <div class="d-flex color-bg-grey">
              <v-col class="color-bg-grey" cols="4" v-for="(itemGroup, i) in itemsGroup" :key="i">
                <v-list class="color-bg-grey mb-0 pb-0">
                  <v-list-item base-color="deep-orange" class="mb-0 pb-0 text-grey-lighten-5 text-uppercase text-subtitle-1">{{itemGroup.description}}</v-list-item>
                </v-list>
                <v-list  class="color-bg-grey mt-0 pt-0">
                  <v-list-item
                      base-color="deep-orange"
                      class="hover-list"
                      route
                      v-for="(item, i) in farticleCategs.filter(x => x.articleCategGroup === itemGroup.id)"
                      :key="i"
                      :value="i"
                      :to="`/public-arsip/` + encryptText(item.id.toString())"
                  >
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">{{ item.description }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-divider vertical color="grey-lighten-3" class="my-6"></v-divider>
              <v-col class="color-bg-grey" cols="4">
                <v-list class="color-bg-grey mb-0 pb-0">
                  <v-list-item class="mb-0 pb-0 text-grey-lighten-5 text-uppercase text-subtitle-1">DATA dan Informasi Lainnya</v-list-item>
                </v-list>
                <v-list class="color-bg-grey mt-0 pt-0">
                  <v-list-item base-color="deep-orange" route to="/public-sop" value="sop" class="hover-list">
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">SOP</v-list-item-title>
                  </v-list-item>
                  <v-list-item base-color="deep-orange" route to="/public-produk-hukum" value="produk-hukum" class="hover-list">
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">Produk Hukum</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-divider vertical color="grey-lighten-3" class="my-6"></v-divider>
              <v-col class="color-bg-grey" cols="4">
                <v-list class="color-bg-grey mb-0 pb-0">
                  <v-list-item class="mb-0 pb-0 text-grey-lighten-5 text-uppercase text-subtitle-1">STATISTIK</v-list-item>
                </v-list>
                <v-list class="color-bg-grey mt-0 pt-0">
                  <v-list-item base-color="deep-orange" route to="/public-lilin-desa" value="lilin-desa" class="hover-list">
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">Lilin Desa</v-list-item-title>
                  </v-list-item>
                  <v-list-item base-color="deep-orange" route to="/public-pemuda-desa" value="pemuda-desa" class="hover-list">
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">Pemuda Desa</v-list-item-title>
                  </v-list-item>
                  <v-list-item base-color="deep-orange" route to="/public-desa-presisi" value="desa-presisi" class="hover-list">
                    <v-list-item-title class="text-grey text-uppercase text-subtitle-1">Desa Presisi</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-col>
            </div>
          </v-card>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-items>
        <div>
          <v-img
            lazy
            width="120"
            :src="require('@/assets/images/logo-menubar1.png')"
          ></v-img>
        </div>
      </v-toolbar-items>
    </v-toolbar>
    </v-container>
  </nav>
  <v-navigation-drawer
      v-model="drawer"
      v-if="showNav && isMobile"
      temporary
      location="left"
      :scrim="true"
      elevation="8"
      class="hidden-md-and-up mobile-drawer">
    <v-layout column>
      <div class="d-flex flex-row justify-center align-center mt-3 mb-2">
        <v-img
            lazy-src="../assets/logo.png"
            max-height="50"
            max-width="50"
            src="../assets/logo.png"
        ></v-img>
      </div>
      <div class="font-weight-light title ml-1">
        <span class="font-weight-black teks-effect-toright">DPMD</span>
        <div
            class="narrow-letter-spacing subtitle-2 mt-n3 text-grey text--darken-2 font-weight-regular"
        >
          Kabupaten Bekasi
        </div>
      </div>

    </v-layout>

    <v-divider></v-divider>
    <v-list>
      <v-list-item color="deep-orange" base-color="black" route to="/home">
        <template #prepend>
          <v-icon>mdi-home</v-icon>
        </template>
        <v-list-item-subtitle>Beranda</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-profil">
        <template #prepend>
          <v-icon>mdi-bank</v-icon>
        </template>
        <v-list-item-subtitle>Profil</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-berita">
        <template #prepend>
          <v-icon>mdi-newspaper-variant</v-icon>
        </template>
        <v-list-item-subtitle>Berita</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-ppid">
        <template #prepend>
          <v-icon>mdi-cogs</v-icon>
        </template>
        <v-list-item-subtitle>PPID</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-layanan">
        <template #prepend>
          <v-icon>mdi-account-cog</v-icon>
        </template>
        <v-list-item-subtitle>Layanan</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-saran">
        <template #prepend>
          <v-icon>mdi-newspaper</v-icon>
        </template>
        <v-list-item-subtitle>Saran & Pengaduan</v-list-item-subtitle>
      </v-list-item>
      <v-list-item color="deep-orange" base-color="black" route to="/public-daftar-survey">
        <template #prepend>
          <v-icon>mdi-account-group</v-icon>
        </template>
        <v-list-item-subtitle>Survei Kepuasan Masyarakat</v-list-item-subtitle>
      </v-list-item>
      <v-list-group value="profil-pegawai">
        <template v-slot:activator="{ props }">
          <v-list-item
              v-bind="props"
              prepend-icon="mdi-book-open-variant"
          >
            <v-list-item-subtitle>Dokumen</v-list-item-subtitle>
          </v-list-item>
        </template>
        <v-list-item
            color="deep-orange"
            base-color="black"
            v-for="(item, i) in farticleCategs"
            :key="i"
            class="text-subtitle-2 text-black"
            :value="item.description"
            :to="`/public-arsip/` + encryptText(item.id.toString())"
        >{{item.description}}</v-list-item>
        <v-list-item color="deep-orange" base-color="black" route to="/public-sop" value="sop">
          <v-list-item-subtitle>SOP</v-list-item-subtitle>
        </v-list-item>
        <v-list-item color="deep-orange" base-color="black" route to="/public-produk-hukum" value="produk-hukum">
          <v-list-item-subtitle>Produk Hukum</v-list-item-subtitle>
        </v-list-item>
        <v-list-item color="deep-orange" base-color="black" route to="/public-lilin-desa" value="lilin-desa">
          <v-list-item-subtitle>Lilin Desa</v-list-item-subtitle>
        </v-list-item>
        <v-list-item color="deep-orange" base-color="black" route to="/public-pemuda-desa" value="pemuda-desa">
          <v-list-item-subtitle>Pemuda Desa</v-list-item-subtitle>
        </v-list-item>
        <v-list-item bcolor="deep-orange" base-color="black" route to="/public-desa-presisi" value="desa-presisi">
          <v-list-item-subtitle>Desa Presisi</v-list-item-subtitle>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { useDisplay } from "vuetify";
import FArticleCategService from "@/services/apiservices-elibrary/f-article-categ-service";
import CryptoJS from "crypto-js";
import EArticleCategGroup from "@/models/e-article-categ-group";
export default {
  name: "NavBar",
  data() {
    return {
      drawer: false,
      isDarkMode: false,
      switchOn: false,
      mdAndUp: null,
      itemsGroup: [
        {id: 1, description: "Dokumen Perencanaan"},
      ],
      farticleCategs: [

      ]
    };
  },
  computed: {
    isMobile() {
      const v = this.mdAndUp;
      // mdAndUp is a Ref from Vuetify useDisplay; templates may not always unwrap it when stored in data.
      const mdUp = v && typeof v === 'object' && 'value' in v ? v.value : !!v;
      return !mdUp;
    },
    showNav() {
      const excludePaths = [
        "/login", "/register",
        "/registration-active",
        "/reset-success",

        "/reset-atur-ulang",
        "/reset-masukkan-otp",
        "/reset-masukkan-otp-password"
      ];

      const currentPath = this.$route.path;

      return !excludePaths.some((path) => currentPath.startsWith(path));
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    // routeToArsip(item) {
    //   // this.$router.push(
    //   //     "/public-event-webinar-detail/" + this.linkNeated(item.id.toString())
    //   // );
    //   this.$router.push(
    //       "/public-arsip/" + this.encryptText(item.farticleCategBean.toString())
    //   );
    //
    // },
    encryptText(teks) {
      const  secretKey = 'DESGREEN#1'
      const ciphertext = CryptoJS.AES.encrypt(teks, secretKey).toString();
      return ciphertext.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    },
    fetchArticleCateg(){
      FArticleCategService.getAllFArticleCategPublic().then(
          (response) => {
            this.farticleCategs = response.data.filter((x) => x.statusActive === true && x.articleCategGroup === EArticleCategGroup.DATA_PERENCANAAN)
          }
      )
    },
    linkNeated(link) {
      return link.replace(/\s+/g, "-").toLocaleLowerCase();
    },
    isActive(path) {
      return this.$route.path === path;
    },
    isSurveyRouteActive() {
      return this.$route.path === "/public-daftar-survey" || this.$route.path.startsWith("/public-survey");
    },
    routeToPage(path){
      if(path !== ""){
        this.$router.push(path)
      }
    }
  },
  mounted() {
    this.fetchArticleCateg()
  },
  created() {
    // Gunakan useDisplay untuk mendapatkan status breakpoint
    const { mdAndUp } = useDisplay();
    this.mdAndUp = mdAndUp;
  },
};
</script>



<style scoped>
.app-nav{

  height: 82px;      /* sesuaikan */
  display: flex;
  align-items: center;

  background: rgba(255,255,255);
  box-shadow: 0 2px 4px rgba(0,0,0,0.12);
  backdrop-filter: blur(10px);

  transition: background-color 220ms ease, box-shadow 220ms ease, backdrop-filter 220ms ease, transform 220ms ease;
}
.color-bg-primary {
  background-color: #FF8030;
}
.color-bg-grey {
  background-color: #2C3137 !important;
}
.color-text-primary {
  color: #FF8030;
}
.color-text-second {
  color: #002647;
}
.teks-effect-toright {
  font-size: 0px;
  font-weight: bolder;
  letter-spacing: 3px;
  text-transform: uppercase;
  text-align: center;

  background: linear-gradient(to right, #3f51b5, #2196f3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradient 5s ease infinite;

  text-transform: uppercase;
  background-image: linear-gradient(
    -225deg,
    #231557 0%,
    #44107a 29%,
    #ff1361 67%,
    #fff800 100%
  );

  background-size: auto auto;
  background-clip: border-box;
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
  font-size: 22px;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}

.waviy {
  position: relative;
  font-weight: bolder;
}
.waviy span {
  position: relative;
  display: inline-block;
  font-size: 40px;
  color: #0f2270;
  text-transform: uppercase;
  animation: flip 2s infinite;
  animation-delay: calc(0.2s * var(--i));
}
@keyframes flip {
  0%,
  80% {
    transform: rotateY(360deg);
  }
}

.custom-btn {
  transition: all 0.5s ease; /* Menambahkan transisi halus */
  color: #000000; /* Warna teks */
  background-color: #ffffff; /* Warna latar belakang */
  border-radius: 1px; /* Sudut tombol */
  letter-spacing: 0px;
}

.custom-btn:hover {
  transition: all 0.5s ease; /* Menambahkan transisi halus */
  color: white;
  background-color: #FF8030; /* Warna latar belakang tipis saat hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan saat dihover */
}
.hover-list:hover .v-list-item-title {
  color: #FF8030 !important;
}
.hover-list:hover{
  background-color: #41454f !important;
}
.btn-switch-on {
  color: white;
  background-color: #FF8030; /* Warna latar belakang tipis saat hover */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Bayangan saat dihover */
}
.mobile-drawer :deep(.v-navigation-drawer__content) {
  /* keep content scrollable on mobile */
  overflow-y: auto;
}

.mobile-drawer {
  z-index: 10000 !important;
}

.mobile-drawer :deep(.v-overlay__scrim) {
  z-index: 9999 !important;
}

</style>
